export const environment = {
  pooling_max_iterations_existing_payment: 8,
  pooling_interval: 3,
};
